import { useState, useEffect } from 'react';
import { Tabs, Slider, Row, Col, Card, Button, Skeleton, Spin, Typography, Tooltip, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';
import { isMobileOnly } from 'react-device-detect';
import editIcon from '../../../../assets/onboarding/editIcon.svg';
import infoIcon from '../../../../assets/onboarding/infoIcon.svg';
import logoMortgage from '../../../../assets/onboarding/logo.svg';
import logoMortgageMobile from '../../../../assets/onboarding/logoMortgageMobile.svg';
import CalculationMortgageAmount from '../Modals/CalculationMortgageAmount';
import SavingsCalculation from '../Modals/SavingsCalculation';
import ComplicatedViability from '../../Components/ComplicatedViability';
import EditData from './EditData';
import { titlePageMobile } from '../../../HerramientasVenta/reusableItems';
import Viability from './Viability';
import { useParams } from 'react-router-dom';
import { setDataViabilityForMortgage } from '../../../../store/viability/actions';
import { useSelector, useDispatch } from 'react-redux';
import env from '../../../../environment';
import axios from 'axios';
import i18n from 'i18next';
import { VIABILITYDATA } from '../../../../store/viability/constants';
import { stages } from '../../../../store/auth/actions';
import { useNavigate } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import CondictionsLegal from './CondictionsLegal';
import viabilityIcon1 from '../../../../assets/onboarding/viabilityIcon1.png';
import viabilityIcon2 from '../../../../assets/onboarding/viabilityIcon2.png';
import viabilityIcon3 from '../../../../assets/onboarding/viabilityIcon3.png';
import { trace } from '../../../../components/tagmanager';
import _ from 'lodash';

const { Text } = Typography;

const ResultAndViabilityGeneral = ({ dataOperation, refreshData }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { operationId } = useParams();
    const antIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;
    const [visibleModalCalculationAmount, setVisibleModalCalculationAmount] = useState(false);
    const [visibleModalSavings, setVisibleModalSavings] = useState(false);
    const [loading, setLoading] = useState(false);
    const [, setRecalculateViability] = useState(false);
    const [changePages, setChangesPages] = useState(1);
    const viabilityData = useSelector((state) => state.viability.viabilityData);
    const operationIdViability = useSelector((state) => state.viability.operationIdViability);
    const userToken = useSelector((state) => state.auth.token);
    const [age, setAge] = useState(undefined);

    useEffect(() => {
        if (
            (viabilityData === undefined && operationIdViability === undefined) ||
            (operationIdViability !== undefined && operationIdViability !== operationId)
        ) {
            dispatch(setDataViabilityForMortgage(operationId, userToken));
        }
        changesStage('process', 'basicCompleted', true)
    }, []);

    useEffect(() => {
        if (viabilityData) {
            trace({
                location,
                userToken,
                operationType: 'mortgage',
                stage: 'basic_02_OK',
                operationName: operationId,
                viability: _.get(viabilityData, 'viability'),
                maxBudget: _.get(viabilityData, 'operation.property')
            });
        }
    }, [viabilityData]);

    const DocumentsResidentMortgageEs =
        'https://gibobs-prod-cdn.s3.eu-central-1.amazonaws.com/documents/docu_bienvenida_hipoteca_residentes_es.pdf';
    const DocumentsResidentMortgageEn =
        'https://gibobs-prod-cdn.s3.eu-central-1.amazonaws.com/documents/docu_bienvenida_hipoteca_residentes_en.pdf';
    const DocumentsResidentMortgageCat =
        'https://gibobs-prod-cdn.s3.eu-central-1.amazonaws.com/documents/docu_bienvenida_hipoteca_residentes_cat.pdf';

    let documentToDownload;

    if (i18n.language === 'es' || i18n.language === 'es-ES') {
        documentToDownload = DocumentsResidentMortgageEs;
    } else if (i18n.language === 'en') {
        documentToDownload = DocumentsResidentMortgageEn;
    } else {
        documentToDownload = DocumentsResidentMortgageCat;
    }

    const typeOfQuote = (
        title,
        index,
        quote,
        fixed,
        titleVariable,
        fixedTin,
        quote1,
        variable,
        years
    ) => {
        return (
            <Col span={!isMobileOnly ? 12 : 24} style={{ marginTop: 8 }}>
                {viabilityData !== undefined ? (
                    <div
                        className={'viability-quote'}
                        style={{ height: '100%', padding: isMobileOnly && 16 }}>
                        <div className="title" style={{ marginBottom: 16 }}>
                            {t(title)} <sup>{index}</sup>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <div className="quote" style={{ color: '#757575' }}>
                                {title === 'typeFixed.bonificate' ||
                                    title === 'typeVar.bonificate' ||
                                    title === 'typeMixed.bonificate'
                                    ? t('__sabadell-es__onboarding.relatedProducts') + ':'
                                    : t('onboarding.noRelatedProducts')}
                            </div>
                            {(title === 'typeFixed.bonificate' ||
                                title === 'typeVar.bonificate' ||
                                title === 'typeMixed.bonificate') && (
                                    <div style={{ display: 'flex', marginTop: -4 }}>
                                        <Tooltip title={t('icon.viability1')}>
                                            <img src={viabilityIcon1} alt="house" style={{ width: 28, height: 28 }}></img>
                                        </Tooltip>
                                        <Tooltip title={t('icon.viability2')}>
                                            <img src={viabilityIcon2} alt="heart" style={{ width: 28, height: 28 }}></img>
                                        </Tooltip>
                                        <Tooltip title={t('icon.viability3')}>
                                            <img src={viabilityIcon3} alt="lock" style={{ width: 28, height: 28 }}></img>
                                        </Tooltip>
                                    </div>
                                )}
                        </div>
                        <div
                            className="wrapper-quote"
                            style={{
                                marginBottom: 0,
                                justifyContent: isMobileOnly ? 'center' : 'space-between',
                                flexDirection: isMobileOnly && 'column',
                                marginTop: 16
                            }}>
                            <div style={{ alignSelf: isMobileOnly ? 'start' : undefined }}>
                                {
                                    <div
                                        className="quote"
                                        style={{
                                            color: '#757575',
                                            textAlign: 'left',
                                            marginBottom: 4
                                        }}>
                                        {title === 'typeVar.bonificate' || title === 'typevar.nobonificate'
                                            ? t('onboarding.quoteFirstYear')
                                            : title === 'typeMixed.bonificate' || title === 'typeMixed.nobonificate2'
                                                ? `Cuota ${years} primeros años`
                                                : t('viability.monthlyPayments')}
                                    </div>
                                }
                                <div className="price" style={{ textAlign: 'left' }}>
                                    {quote < 0 ? numeral(0).format('0,0 $') : numeral(quote).format('0,0 $')}/
                                    {t('viability.monthsEstimated')}
                                </div>
                            </div>
                            <div style={{ alignSelf: 'end', marginTop: isMobileOnly ? -20 : undefined }}>
                                {!isMobileOnly && (
                                    <div className="quote" style={{ color: '#757575', height: 24 }}></div>
                                )}
                                <div className="price-variable" style={{ fontWeight: 700 }}>
                                    {t('appraisal.nameTableTin')}: {numeral(fixedTin).format('0,0.00') + '%'}{' '}
                                </div>
                            </div>
                        </div>
                        {titleVariable !== 'onboarding.fixedSpread' && (
                            <div
                                className="wrapper-quote"
                                style={{
                                    marginBottom: 0,
                                    marginBottom: 0,
                                    justifyContent: isMobileOnly ? 'center' : 'space-between',
                                    flexDirection: isMobileOnly && 'column',
                                    marginTop: 16
                                }}>
                                <div style={{ alignSelf: isMobileOnly ? 'start' : undefined }}>
                                    {
                                        <div className="quote" style={{ color: '#757575', textAlign: 'left' }}>
                                            {t('onboarding.quoteRestYear')}
                                        </div>
                                    }
                                    <div className="price" style={{ textAlign: 'left' }}>
                                        {quote1 < 0 ? numeral(0).format('0,0 $') : numeral(quote1).format('0,0 $')}/
                                        {t('viability.monthsEstimated')}
                                    </div>
                                </div>
                                <div style={{ alignSelf: 'end', marginTop: isMobileOnly ? -20 : undefined }}>
                                    {!isMobileOnly && (
                                        <div className="quote" style={{ color: '#757575', height: 24 }}></div>
                                    )}
                                    <div className="price-variable" style={{ fontWeight: 700 }}>
                                        {t('appraisal.nameTableTin')}: {' EUR + '} {numeral(variable).format('0,0.00')}
                                        {'%'}
                                    </div>
                                </div>
                            </div>
                        )}
                        <Divider style={{ color: "#E0E0E0", background: "#E0E0E0", height: 2 }}></Divider>
                        <div
                            className="percentage"
                            style={{ marginBottom: 8, fontWeight: 700, marginTop: 8 }}>
                            {title === 'typeFixed.bonificate' || title === 'typeFixed.nobonificate'
                                ? t('appraisal.nameTableTae')
                                : t('appraisal.nameTableTae') + ' Variable'}
                            : {numeral(fixed).format('0,0.00') + '%'}
                        </div>
                    </div>
                ) : (
                    <div className="viability-quote">
                        <Skeleton active />
                        <div className="savings">
                            <Skeleton active />
                        </div>
                    </div>
                )}
            </Col>
        );
    };

    const viabialityData = (type, name) => {
        return (
            viabilityData &&
            viabilityData.operation &&
            viabilityData.operation.types &&
            viabilityData.operation.types[type] &&
            viabilityData.operation.types[type][name]
        );
    };

    const disbledButton = () => {
        return viabilityData && viabilityData && viabilityData.excepcionalViability === 'NOSAVINGS'
            ? true
            : viabilityData && viabilityData.excepcionalViability === 'INCOME_LEVEL'
                ? true
                : viabilityData && viabilityData.excepcionalViability === 'MORTGAGE_AMOUNT'
                    ? true
                    : false;
    };

    const calculateViability = (value) => {
        if (value > 5) {
            dispatch({
                type: VIABILITYDATA,
                payload: undefined
            });
            axios
                .post(
                    `${env.api.url}/mortgages/conventional-viability-mortgage/calculate-viability/${operationId}`,
                    {
                        overrides: {
                            quotes: value * 12
                        }
                    },
                    {
                        headers: { Authorization: `Bearer ${userToken}` }
                    }
                )
                .then((response) => {
                    if (response.data.success) {
                        refreshData();
                        dispatch({
                            type: VIABILITYDATA,
                            payload: response.data.data
                        });
                    }
                })
                .catch((error) => {
                    console.log(error)
                });
        }
    };
    const changesStage = (owner, key, value) => {
        setLoading(true);
        axios
            .post(
                `${env.api.url}/v1/mortgages/data/update/${operationId}`,
                { key, participant: owner, value },
                {
                    headers: { Authorization: `Bearer ${userToken}` }
                }
            )
            .then((response) => {
                if (response.data.success) {
                    axios
                        .post(
                            `${env.api.url}/v1/mortgages/check-full-declaratives`,
                            { operationId: operationId },
                            {
                                headers: { Authorization: `Bearer ${userToken}` }
                            }
                        )
                        .then((response) => {
                            if (response.data.success) {
                                axios
                                    .get(`${env.api.url}/v1/auto-things/AutoStagesGenerator/${operationId}`, {
                                        headers: {
                                            Authorization: `Bearer ${userToken}`
                                        }
                                    })
                                    .then((response) => {
                                        if (response.data.success) {
                                            dispatch(stages(response.data.data.currentStage));
                                            navigate(`/operations/${operationId}/${response.data.data.currentStage}`);
                                            setLoading(false);
                                        }
                                    });
                            }
                        });
                }
            });
    };

    const renderMin = (viabilityData) => {
        const min = viabilityData?.operation?.quotes / 12;
        if (min === 5) {
            return 0;
        } else {
            return 5;
        }
    };
    return (<></>);
    // return (<>
    //     {changePages === 2 && (
    //         <EditData
    //             changePage={titlePageMobile((e) => setChangesPages(e), 1, t('loan.editData'))}
    //             type="mortgage"
    //             dataOperation={dataOperation}
    //             refreshData={() => refreshData()}
    //             setPages={(e) => setChangesPages(e)}
    //             setRecalculateViability={(e) => setRecalculateViability(e)}
    //         />
    //     )}
    //     {changePages === 1 &&
    //         (!loading ? (
    //             <div
    //                 style={{
    //                     padding: isMobileOnly ? 16 : 24,
    //                     marginBottom: 220
    //                 }}>
    //                 <div
    //                     style={{
    //                         display: 'flex',
    //                         justifyContent: 'space-between',
    //                         alignItems: 'center',
    //                         marginBottom: isMobileOnly ? 26 : -20
    //                     }}>
    //                     <div></div>
    //                     {viabilityData &&
    //                         viabilityData.excepcionalViability !== 'NOSAVINGS' &&
    //                         viabilityData.excepcionalViability !== 'INCOME_LEVEL' &&
    //                         viabilityData.excepcionalViability !== 'MORTGAGE_AMOUNT' && (
    //                             <div
    //                                 style={{
    //                                     display: 'flex',
    //                                     justifyContent: 'space-between',
    //                                     alignItems: 'center'
    //                                 }}>
    //                                 <img src={editIcon} alt="Gibobs" height={20} />
    //                                 <div
    //                                     style={{
    //                                         color: '#006DFF',
    //                                         fontSize: 14,
    //                                         fontWeight: 500,
    //                                         lineHeight: '20px',
    //                                         marginLeft: 4,
    //                                         cursor: 'pointer'
    //                                     }}
    //                                     onClick={() => {
    //                                         setChangesPages(2);
    //                                         setAge(undefined);
    //                                     }}>
    //                                     {t('loan.editData')}
    //                                 </div>
    //                             </div>
    //                         )}
    //                 </div>

    //                 {/* START CONDICIONES DE VIABIALIDAD COMPLICADA */}
    //                 {viabilityData && viabilityData.excepcionalViability === 'NOSAVINGS' && (
    //                     <ComplicatedViability
    //                         title={'onboarding.cantBuyWithoutSavings'}
    //                         description={'onboarding.cantBuyWithoutSavingsDescription'}
    //                         reason={'Pre-scoring'}
    //                         subReason={'Ahorros insufientes - cierre automático'}
    //                         descriptionToClose={'Ahorros insufientes'}
    //                         setPages={(e) => setChangesPages(e)}
    //                     />
    //                 )}
    //                 {viabilityData && viabilityData.excepcionalViability === 'INCOME_LEVEL' && (
    //                     <ComplicatedViability
    //                         title={'onboarding.lowIncomeLevel'}
    //                         description={'onboarding.lowIncomeLevelDescription'}
    //                         reason={'Pre-scoring'}
    //                         subReason={'Ingresos bajos - cierre automático'}
    //                         descriptionToClose={'Ingresos bajos'}
    //                         setPages={(e) => setChangesPages(e)}
    //                     />
    //                 )}
    //                 {viabilityData && viabilityData.excepcionalViability === 'MORTGAGE_AMOUNT' && (
    //                     <ComplicatedViability
    //                         title={'onboarding.ItsBetterTellTruth'}
    //                         description={'onboarding.ItsBetterTellTruthDescription'}
    //                         reason={'Pre-scoring'}
    //                         subReason={'Importe de hipoteca'}
    //                         descriptionToClose={'Importe de hipoteca bajo'}
    //                         setPages={(e) => setChangesPages(e)}
    //                     />
    //                 )}

    //                 <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 26 }}>
    //                     <Text style={{ fontSize: 24, color: '#000000', fontWeight: 700 }}>
    //                         {t('viability.resultTitle')}
    //                     </Text>
    //                 </div>

    //                 <div
    //                     className="offer-detail"
    //                     style={{
    //                         marginBottom: 24,
    //                         marginTop: viabilityData?.excepcionalViability !== undefined && -10
    //                     }}>
    //                     <div className="wrapper">
    //                         <div
    //                             style={{
    //                                 display: 'flex',
    //                                 columnGap: 4,
    //                                 alignItems: 'center',
    //                                 marginTop: isMobileOnly ? undefined : 0
    //                             }}>
    //                             <div className="offer-style">{t('onboarding.mortgageAmount')}</div>
    //                             <img
    //                                 src={infoIcon}
    //                                 alt="infoIcon"
    //                                 onClick={() => setVisibleModalCalculationAmount(true)}
    //                                 height={20}
    //                             />

    //                             <div className="offer-style" style={{ color: '#006DFF', fontWeight: 600 }}>
    //                                 {viabilityData !== undefined ? (
    //                                     numeral(viabilityData?.operation?.mortgageAmountNoBonifications).format(
    //                                         '0,0.00 $'
    //                                     )
    //                                 ) : (
    //                                     <Skeleton.Input active />
    //                                 )}
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>

    //                 {/* FINISH CONDICIONES DE VIABIALIDAD COMPLICADA */}
    //                 {viabilityData && viabilityData.operation && (
    //                     <div style={{ width: !isMobileOnly && 760, margin: 'auto' }}>
    //                         <div
    //                             style={{
    //                                 display: 'flex',
    //                                 alignItems: 'center',
    //                                 marginTop: 24,
    //                                 justifyContent: 'center'
    //                             }}>
    //                             <div
    //                                 style={{
    //                                     fontWeight: 400,
    //                                     fontSize: 12,
    //                                     lineHeight: '16px',
    //                                     color: '#2F4858',
    //                                     marginRight: 5
    //                                 }}>
    //                                 {t('appraisal.nameTableTerm')}
    //                             </div>

    //                             <Slider
    //                                 defaultValue={
    //                                     viabilityData &&
    //                                     viabilityData.operation &&
    //                                     viabilityData.operation.quotes / 12
    //                                 }
    //                                 railStyle={{ background: '#FFFFFF' }}
    //                                 getTooltipPopupContainer={(node) => node.parentNode}
    //                                 style={{ width: '50%' }}
    //                                 onAfterChange={(e) => calculateViability(e)}
    //                                 onChange={(e) => setAge(e)}
    //                                 disabled={
    //                                     viabilityData && viabilityData?.operation?.quotes / 12 === 5 ? true : false
    //                                 }
    //                                 max={
    //                                     dataOperation && dataOperation.owner1 && dataOperation.owner1.age < 35
    //                                         ? 30
    //                                         : 75 -
    //                                             Number(
    //                                                 dataOperation && dataOperation.owner1 && dataOperation.owner1.age
    //                                             ) >
    //                                             5
    //                                             ? 75 -
    //                                                 Number(
    //                                                     dataOperation && dataOperation.owner1 && dataOperation.owner1.age
    //                                                 ) >
    //                                                 30
    //                                                 ? 30
    //                                                 : 75 -
    //                                                 Number(
    //                                                     dataOperation && dataOperation.owner1 && dataOperation.owner1.age
    //                                                 )
    //                                             : 5
    //                                 }
    //                                 min={viabilityData && renderMin(viabilityData)}
    //                                 tooltip={{
    //                                     formatter: (value) => `${value} ${t('form.years')}`
    //                                 }}
    //                             />
    //                             <div style={{ textAlign: 'right', marginLeft: 5 }}>
    //                                 {age !== undefined
    //                                     ? age
    //                                     : dataOperation && dataOperation.owner1 && dataOperation.owner1.age < 35
    //                                         ? 30
    //                                         : 75 -
    //                                             Number(
    //                                                 dataOperation && dataOperation.owner1 && dataOperation.owner1.age
    //                                             ) >
    //                                             5
    //                                             ? 75 -
    //                                                 Number(
    //                                                     dataOperation && dataOperation.owner1 && dataOperation.owner1.age
    //                                                 ) >
    //                                                 30
    //                                                 ? 30
    //                                                 : 75 -
    //                                                 Number(dataOperation && dataOperation.owner1 && dataOperation.owner1.age)
    //                                             : 5}
    //                                 años
    //                             </div>
    //                         </div>
    //                     </div>
    //                 )}
    //                 <Tabs
    //                     className={
    //                         isMobileOnly ? 'tabs-onboarding-mortgage-mobile' : 'tabs-onboarding-mortgage'
    //                     }
    //                     defaultActiveKey="1"
    //                     centered
    //                     style={{
    //                         marginBottom: 200,
    //                         width: !isMobileOnly && 900,
    //                         margin: 'auto'
    //                     }}>
    //                     <Tabs.TabPane
    //                         tab={
    //                             isMobileOnly
    //                                 ? t('mortgage.fixedtabmob').toUpperCase()
    //                                 : t('mortgage.fixedtab').toUpperCase()
    //                         }
    //                         key="1">
    //                         <Row gutter={24} style={{ margin: '0px -8px 24px' }}>
    //                             {typeOfQuote(
    //                                 'typeFixed.bonificate',
    //                                 '6',
    //                                 viabialityData('fixedTin', 'quote'),
    //                                 viabialityData('fixedTin', 'tae') * 100,
    //                                 'onboarding.fixedSpread',
    //                                 viabialityData('fixedTin', 'spread') * 100
    //                             )}
    //                             {typeOfQuote(
    //                                 'typeFixed.nobonificate',
    //                                 '7',
    //                                 viabialityData('fixedTinWithoutBonifications', 'quote'),
    //                                 viabialityData('fixedTinWithoutBonifications', 'tae') * 100,
    //                                 'onboarding.fixedSpread',
    //                                 viabialityData('fixedTinWithoutBonifications', 'spread') * 100
    //                             )}
    //                         </Row>

    //                         {viabilityData &&
    //                             viabilityData.excepcionalViability !== 'NOSAVINGS' &&
    //                             viabilityData.excepcionalViability !== 'INCOME_LEVEL' &&
    //                             viabilityData.excepcionalViability !== 'MORTGAGE_AMOUNT' && (
    //                                 <div
    //                                     style={{
    //                                         border: '1px solid #006DFF',
    //                                         borderRadius: 4,
    //                                         padding: 24,
    //                                         margin: '0px 0px 24px',
    //                                         textAlign: 'center',
    //                                         background: '#FFFFFF',
    //                                         display: 'flex',
    //                                         textAlign: 'left',
    //                                         columnGap: !isMobileOnly && 24,
    //                                         flexDirection: isMobileOnly && 'column',
    //                                         rowGap: isMobileOnly && 16
    //                                     }}>
    //                                     <img
    //                                         src={isMobileOnly ? logoMortgageMobile : logoMortgage}
    //                                         alt="logoMortgage"
    //                                         height={'100%'}
    //                                     />
    //                                     <div>
    //                                         <div
    //                                             className="title-less-pay"
    //                                             style={{
    //                                                 marginBottom: 16
    //                                             }}>
    //                                             {t('onboarding.wantPayLessNew')}
    //                                         </div>
    //                                         <div className="sub-title-less-pay">
    //                                             {t('onboarding.goAheadToAnalyzeNew')}
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             )}
    //                     </Tabs.TabPane>
    //                     <Tabs.TabPane
    //                         tab={
    //                             isMobileOnly
    //                                 ? t('mortgage.mixedtabmob').toUpperCase()
    //                                 : t('mortgage.mixedtab').toUpperCase()
    //                         }
    //                         key="2">
    //                         <Row gutter={24} style={{ margin: '0px -8px 24px' }}>
    //                             {typeOfQuote(
    //                                 'typeMixed.bonificate',
    //                                 '2', // Superindice del TAE
    //                                 viabialityData('mixedTin', 'sections')?.[0]?.monthlyPayment,
    //                                 viabialityData('mixedTin', 'tae') * 100,
    //                                 'mixedType',
    //                                 viabialityData('mixedTin', 'sections')?.[0]?.tin * 100,
    //                                 viabialityData('mixedTin', 'sections')?.[1]?.monthlyPayment,
    //                                 viabialityData('mixedTin', 'sections')?.[1]?.tin * 100,
    //                                 (viabialityData('mixedTin', 'sections')?.[0]?.to + 1) / 12
    //                             )}
    //                             {typeOfQuote(
    //                                 'typeMixed.nobonificate2',
    //                                 '3', // Superindice del TAE
    //                                 viabialityData('mixedTinWithoutBonifications', 'sections')?.[0]?.monthlyPayment,
    //                                 viabialityData('mixedTinWithoutBonifications', 'tae') * 100,
    //                                 'mixedType',
    //                                 viabialityData('mixedTinWithoutBonifications', 'sections')?.[0]?.tin * 100,
    //                                 viabialityData('mixedTinWithoutBonifications', 'sections')?.[1]?.monthlyPayment,
    //                                 viabialityData('mixedTinWithoutBonifications', 'sections')?.[1]?.tin * 100,
    //                                 (viabialityData('mixedTin', 'sections')?.[0]?.to + 1) / 12
    //                             )}
    //                         </Row>

    //                         {viabilityData &&
    //                             viabilityData.excepcionalViability !== 'NOSAVINGS' &&
    //                             viabilityData.excepcionalViability !== 'INCOME_LEVEL' &&
    //                             viabilityData.excepcionalViability !== 'MORTGAGE_AMOUNT' && (
    //                                 <div
    //                                     style={{
    //                                         border: '1px solid #006DFF',
    //                                         borderRadius: 4,
    //                                         padding: 24,
    //                                         margin: '0px 0px 24px',
    //                                         textAlign: 'center',
    //                                         background: '#FFFFFF',
    //                                         display: 'flex',
    //                                         textAlign: 'left',
    //                                         columnGap: !isMobileOnly && 24,
    //                                         flexDirection: isMobileOnly && 'column',
    //                                         rowGap: isMobileOnly && 16
    //                                     }}>
    //                                     <img
    //                                         src={isMobileOnly ? logoMortgageMobile : logoMortgage}
    //                                         alt="logoMortgage"
    //                                         height={'100%'}
    //                                     />
    //                                     <div>
    //                                         <div
    //                                             className="title-less-pay"
    //                                             style={{
    //                                                 marginBottom: 16
    //                                             }}>
    //                                             {t('onboarding.wantPayLessNew')}
    //                                         </div>
    //                                         <div className="sub-title-less-pay">
    //                                             {t('onboarding.goAheadToAnalyzeNew')}
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             )}
    //                     </Tabs.TabPane>
    //                     <Tabs.TabPane
    //                         tab={
    //                             isMobileOnly
    //                                 ? t('mortgage.varTabMob').toUpperCase()
    //                                 : t('mortgage.varTab').toUpperCase()
    //                         }
    //                         key="3">
    //                         <Row gutter={24} style={{ margin: '0px -8px 24px' }}>
    //                             {typeOfQuote(
    //                                 'typeVar.bonificate',
    //                                 '4', // Superindice del TAE
    //                                 viabialityData('variableTin', 'sections')?.[0]?.monthlyPayment,
    //                                 viabialityData('variableTin', 'tae') * 100,
    //                                 'viability.variableSpread',
    //                                 viabialityData('variableTin', 'sections')?.[0]?.tin * 100, //  fixedTin TIN PRIMER AÑO,
    //                                 viabialityData('variableTin', 'sections')?.[1]?.monthlyPayment, //  quote1 CUOTA RESTO DE AÑOS,
    //                                 viabialityData('variableTin', 'sections')?.[1]?.tin * 100 //  variable TIN RESTO AÑOS,
    //                             )}
    //                             {typeOfQuote(
    //                                 'typevar.nobonificate',
    //                                 '5', // Superindice del TAE
    //                                 viabialityData('variableTinWithoutBonifications', 'sections')?.[0]
    //                                     ?.monthlyPayment,
    //                                 viabialityData('variableTinWithoutBonifications', 'tae') * 100,
    //                                 'viability.variableSpread',
    //                                 viabialityData('variableTinWithoutBonifications', 'sections')?.[0]?.tin * 100, //  fixedTin TIN PRIMER AÑO,
    //                                 viabialityData('variableTinWithoutBonifications', 'sections')?.[1]
    //                                     ?.monthlyPayment, //  quote1 CUOTA RESTO DE AÑOS,
    //                                 viabialityData('variableTinWithoutBonifications', 'sections')?.[1]?.tin * 100 //  variable TIN RESTO AÑOS,
    //                             )}
    //                         </Row>

    //                         {viabilityData &&
    //                             viabilityData.excepcionalViability !== 'NOSAVINGS' &&
    //                             viabilityData.excepcionalViability !== 'INCOME_LEVEL' &&
    //                             viabilityData.excepcionalViability !== 'MORTGAGE_AMOUNT' && (
    //                                 <div
    //                                     style={{
    //                                         border: '1px solid #006DFF',
    //                                         borderRadius: 4,
    //                                         padding: 24,
    //                                         margin: '0px 0px 24px',
    //                                         textAlign: 'center',
    //                                         background: '#FFFFFF',
    //                                         display: 'flex',
    //                                         textAlign: 'left',
    //                                         columnGap: !isMobileOnly && 24,
    //                                         flexDirection: isMobileOnly && 'column',
    //                                         rowGap: isMobileOnly && 16
    //                                     }}>
    //                                     <img
    //                                         src={isMobileOnly ? logoMortgageMobile : logoMortgage}
    //                                         alt="logoMortgage"
    //                                         height={'100%'}
    //                                     />
    //                                     <div>
    //                                         <div
    //                                             className="title-less-pay"
    //                                             style={{
    //                                                 marginBottom: 16
    //                                             }}>
    //                                             {t('onboarding.wantPayLessNew')}
    //                                         </div>
    //                                         <div className="sub-title-less-pay">
    //                                             {t('onboarding.goAheadToAnalyzeNew')}
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             )}
    //                         {isMobileOnly && (
    //                             <div
    //                                 style={{
    //                                     background: '#FFFFFF',
    //                                     borderRadius: 4,
    //                                     padding: 24,
    //                                     margin: '32px 0px'
    //                                 }}>
    //                                 <div
    //                                     style={{
    //                                         fontSize: 14,
    //                                         fontWeight: 400,
    //                                         color: '#757575'
    //                                     }}
    //                                     onClick={() => setChangesPages(2)}
    //                                     dangerouslySetInnerHTML={{
    //                                         __html: t('onboarding.cityzenshipDescription')
    //                                     }}
    //                                 />
    //                             </div>
    //                         )}
    //                     </Tabs.TabPane>
    //                 </Tabs>

    //                 <Card
    //                     className="card-button-style-onboading"
    //                     style={{
    //                         left: 0,
    //                         marginBottom: -2,
    //                         backgroundColor: '#FAFEFE'
    //                     }}>
    //                     <Button
    //                         id="gb-mortgage-buy-situation-mobile"
    //                         className="button-primary-gibobs-inmo"
    //                         type="primary"
    //                         style={{
    //                             fontSize: '14px',
    //                             width: isMobileOnly ? '100%' : 248,
    //                             height: 48,
    //                             fontWeight: 600,
    //                             zIndex: 1200
    //                         }}
    //                         disabled={disbledButton()}
    //                         htmlType="submit"
    //                         onClick={() => changesStage('process', 'basicCompleted', true)}>
    //                         {t('viability.continue')}
    //                     </Button>
    //                 </Card>

    //                 <Viability
    //                     viabilityData={viabilityData && viabilityData}
    //                     viabilityDocument={`${env.api.url}/v1/banks/generate-pdf-viabilidad-casaElegida/${operationId}/${i18n.language}?token=${userToken}`}
    //                     welcomeDocument={documentToDownload}
    //                     setChangesPages={() => setChangesPages(2)}
    //                 />
    //                 <div className="description-viability">
    //                     <CondictionsLegal></CondictionsLegal>
    //                 </div>

    //                 {/* MODALES */}
    //                 <CalculationMortgageAmount
    //                     key={'visibleModalCalculationAmount'}
    //                     visible={visibleModalCalculationAmount}
    //                     onCreate={() => setVisibleModalCalculationAmount(false)}
    //                     onCancel={() => setVisibleModalCalculationAmount(false)}
    //                     width={800}
    //                     viabilityData={viabilityData}
    //                     dataOperation={dataOperation}
    //                 />
    //                 <SavingsCalculation
    //                     key={'visibleModalSavings'}
    //                     visible={visibleModalSavings}
    //                     onCreate={() => setVisibleModalSavings(false)}
    //                     onCancel={() => setVisibleModalSavings(false)}
    //                     width={800}
    //                 />
    //             </div>
    //         ) : (
    //             <Spin indicator={antIcon} className="spin" />
    //         ))}
    // </>);
};

export default ResultAndViabilityGeneral;
